import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IoIosReturnLeft } from "react-icons/io";
import { FaCloudDownloadAlt, FaPlay } from "react-icons/fa";
import "../styles.css";
import VideoModal from '../PlayerModal/Player.jsx';
import MusicModal from '../PlayerModal/MusicPlayer.jsx';
import Conect from '../../../../Api/Conect.js';
import { renderIcon } from "../../../services/renderIcon.js";

const PublicHome = () => {
  const { id } = useParams();
  const [dados, setDados] = useState([]);
  const [mideaUrl, setMideaUrl] = useState("");
  const [playlist, setPlaylist] = useState([]);
  const [currentPath, setCurrentPath] = useState("");
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [isMusicOpen, setIsMusicOpen] = useState(false);

  const musicExtensions = ['.mp3', '.wav', '.wma'];
  const decodedPath = decodeURIComponent(id || "/");


  useEffect(() => {
    if (decodedPath) {
      setCurrentPath(decodedPath);
      getPaths(decodedPath);
    }
  }, [decodedPath]);

  const getPaths = async (path) => {
    try {
      const response = await Conect.post(`/api/files`, { path });
      if (!response.data.erro) {
        setDados(response.data.files);
      } else {
        console.warn("Caminho inválido:", response.data.error);
        // Opcional: voltar para a raiz ou mostrar aviso
      }
    } catch (error) {
      console.error("Erro ao carregar arquivos públicos", error);
    }
  };

  const navigateBack = () => {
    if (currentPath === decodedPath) return; // impede voltar além da raiz compartilhada
    const newPath = currentPath.split('/').slice(0, -1).join('/');
    if (!newPath.startsWith(decodedPath)) {
      setCurrentPath(decodedPath);
      getPaths(decodedPath);
      return;
    }
    setCurrentPath(newPath);
    getPaths(newPath);
  };

  const handleFolderClick = (folderName) => {
    const newPath = `${currentPath}/${folderName}`;
    setCurrentPath(newPath);
    getPaths(newPath);
  };

  const handleFileDownload = (fileName) => {
    const filePath = currentPath.endsWith(fileName)
      ? currentPath
      : `${currentPath}/${fileName}`;

    const fileUrl = `${Conect.defaults.baseURL}/api/download?path=${encodeURIComponent(filePath)}`;
    window.open(fileUrl, '_blank');
  };

  const handlePlayer = (fileName) => {
    const filePath = currentPath.endsWith(fileName)
      ? currentPath
      : `${currentPath}/${fileName}`;

    setMideaUrl(`${Conect.defaults.baseURL}/api/stream?file=${encodeURIComponent(filePath)}`);
    setIsPlayerOpen(true);
  };

  const handleMusicPlaylist = (musicInput, coverName) => {
    let musicArray = [];

    if (Array.isArray(musicInput)) {
      musicArray = musicInput;
    } else {
      musicArray = dados.filter(file => file.name === musicInput);
    }

    const tracks = musicArray.map(file => ({
      name: file.name,
      url: `${Conect.defaults.baseURL}/api/stream?file=${encodeURIComponent(currentPath + '/' + file.name)}`,
      coverUrl: coverName
        ? `${Conect.defaults.baseURL}/api/stream?file=${encodeURIComponent(currentPath + '/' + coverName)}`
        : null
    }));

    setPlaylist(tracks);
    setIsMusicOpen(true);
  };

  const musicFiles = (dados ?? []).filter(file => musicExtensions.includes(file.extension.toLowerCase()));

  return (
    <div className='root'>
      <VideoModal
        isPlayerOpen={isPlayerOpen}
        setIsPlayerOpen={setIsPlayerOpen}
        videoUrl={mideaUrl}
        setVideoUrl={setMideaUrl}
      />
      <MusicModal
        isMusicOpen={isMusicOpen}
        setIsMusicOpen={setIsMusicOpen}
        playlist={playlist}
        setPlaylist={setPlaylist}
      />

      <div className="cont">
        {/* ✅ Só mostra o botão de voltar se NÃO estiver na pasta raiz compartilhada */}
        {currentPath !== decodedPath && (
          <div className="folder" onClick={navigateBack}>
            <IoIosReturnLeft style={{ color: "#ccc" }} className="folder-icon" />
            <div className="folder-name">Voltar</div>
          </div>
        )}

        {musicFiles.length > 1 && (() => {
          const albumArt = dados.find(f =>
            f.name.toLowerCase().startsWith('albumartsmall') &&
            ['.jpg', '.jpeg', '.png'].includes(f.extension.toLowerCase())
          );

          return (
            <div className="folder" onClick={() => handleMusicPlaylist(musicFiles, albumArt?.name)}>
              <FaPlay style={{ color: "#00BFFF", fontSize: 30 }} />
              <div className="folder-name">Playar Tudo...</div>
            </div>
          );
        })()}

        {dados?.map((value, index) => {
          const isImage = ['.jpg', '.jpeg', '.png'].includes(value.extension);

          const renderThumb = () =>
            isImage ? (
              <img
                src={`${Conect.defaults.baseURL}/api/download?path=${encodeURIComponent(currentPath + '/' + value.name)}`}
                alt={value.name}
                className="image-preview"
              />
            ) : renderIcon(value.extension, value.name);

          const renderActions = () => (
            <div>
              {!value.isDirectory && (
                <div className="icon-buttons icon-buttons-donwload">
                  <button onClick={(e) => { e.stopPropagation(); handleFileDownload(value.name); }}>
                    <FaCloudDownloadAlt style={{ color: "#00BFFF" }} />
                  </button>
                </div>
              )}
              {['.mkv', '.mp4', '.avi', '.wmv', '.wav'].includes(value.extension) && (
                <div className="icon-buttons icon-buttons-player">
                  <button onClick={(e) => { e.stopPropagation(); handlePlayer(value.name); }}>
                    <FaPlay style={{ color: "#00BFFF" }} />
                  </button>
                </div>
              )}
            </div>
          );

          return (
            <div
              className="folder"
              key={index}
              onClick={() => value.isDirectory && handleFolderClick(value.name)}
            >
              {renderActions()}
              {renderThumb()}
              <div className="folder-name">{value.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PublicHome;
